async function generateResponse(
	userQuestion,
	setMessages,
	fallback,
	greetingResponses,
	aiResponses
) {
	const normalizedQuestion = userQuestion.toLowerCase();

	function updateMessage(text) {
		setMessages((prev) => [
			...prev.filter((msg) => msg.text !== "Thinking..."),
			{ role: "model", text: text, timestamp: Date.now() },
		]);
	}

	function isGreetingOnly(message) {
		const greetings = [
			"hi",
			"hello",
			"hey",
			"good morning",
			"good afternoon",
			"good evening",
		];
		const words = message.toLowerCase().split(/\s+/);

		return words.some((word) => greetings.includes(word));
	}

	if (isGreetingOnly(userQuestion)) {
		let randomGreeting = {
			answer: fallback,
		};

		if (greetingResponses.length > 0) {
			randomGreeting =
				greetingResponses[Math.floor(Math.random() * greetingResponses.length)];
		}

		const greetID = setTimeout(() => {
			updateMessage(randomGreeting.answer);
		}, 1000);

		return () => clearTimeout(greetID);
	} else {
		const answerChoices = [];
		aiResponses?.forEach((chatbot) => {
			const hasMatch = chatbot?.keywords?.some((kw) =>
				normalizedQuestion.includes(kw.toLowerCase())
			);

			if (hasMatch) {
				answerChoices.push(chatbot.answer);
			}
		});
		let randomGreeting = fallback;

		if (answerChoices.length > 0) {
			randomGreeting =
				answerChoices[Math.floor(Math.random() * answerChoices.length)];
		}

		const greetID = setTimeout(() => {
			updateMessage(randomGreeting);
		}, 1000);

		return () => clearTimeout(greetID);
	}
}

export default generateResponse;
